const investExpertiseSynthesisVentureCapitalLang = {
	title_fund: {
		tag: 'invest.expertise_synthesis_venture_capital.title_fund',
		fr: 'Fonds',
		en: 'Fund',
	},
	title_coinvestment: {
		tag: 'invest.expertise_synthesis_venture_capital.title_coinvestment',
		fr: 'Co-investissement',
		en: 'Co-investment',
	},
	title_total_of_positions: {
		tag: 'invest.expertise_synthesis_venture_capital.title_total_of_positions',
		fr: 'Total des participations',
		en: 'Positions total',
	},
	fund_created_in: {
		tag: 'invest.expertise_synthesis_venture_capital.fund_created_in',
		fr: 'Fonds créé en',
		en: 'Fund created in',
	},
	fund_invested_in: {
		tag: 'invest.expertise_synthesis_venture_capital.fund_invested_in',
		fr: 'Investissement fait en',
		en: 'Investment done in',
	},
};

export default investExpertiseSynthesisVentureCapitalLang;
